export * from './configuracao-global';
